/**
 * ComingSoonPage - Reusable placeholder for features under development
 * Used for Gallery, Vault, Group Chat, Poke, etc.
 */

import { useNavigate } from 'react-router-dom'

interface ComingSoonPageProps {
  feature: string
  icon?: string
}

export function ComingSoonPage({ feature, icon = '🚧' }: ComingSoonPageProps) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-pink-100 px-4">
      <div className="max-w-md w-full text-center space-y-6 animate-slide-up">
        {/* Icon */}
        <div className="text-6xl mb-4">{icon}</div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900">
          {feature}
        </h1>

        {/* Coming Soon Message */}
        <p className="text-xl text-gray-600">
          Coming Soon
        </p>

        <p className="text-sm text-gray-500">
          We're working hard to bring you this feature. Stay tuned!
        </p>

        {/* Back Button */}
        <button
          onClick={() => navigate('/welcome')}
          className="mt-8 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium shadow-sm btn-hover"
        >
          ← Back to Home
        </button>
      </div>
    </div>
  )
}
